import { useState } from "react";
import { MobileMenu } from "./mobileMenu";
import { HamburgerMenu } from "./hamburgerMenu";
import { headerLinks } from "./headerLinks";
import "./section/css/header.css";
import Logo from "../../../assets/images/logo.png"

export const BloombergHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <div className="header-display-desktop" data-content-field="site-title">
                <div
                    className="header-title-nav-wrapper d-flex align-items-center justify-content-between"
                    style={{
                        flexWrap: "wrap",
                        backgroundColor: "#162242",
                        padding: "1rem",
                        paddingTop: "3rem",
                        paddingBottom: "3rem",
                    }}
                >
                    <div className="header-title" data-animation-role="header-element">
                        <div className="header-title-logo">
                            <a href="/" data-animation-role="header-element">
                                <img
                                    src={Logo}
                                    alt="here & now"
                                    style={{ display: "block", maxWidth: "200px", height: "4.25em" }}
                                    loading="eager"
                                    decoding="async"
                                />
                            </a>
                        </div>
                    </div>

                    <div className="d-none d-md-flex align-items-center mt-2">
                        {headerLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                className="links position-relative me-3 text-white text-decoration-none"
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>

                    <HamburgerMenu onClick={() => setMenuOpen(true)} visible={!menuOpen} />
                </div>
            </div>

            {menuOpen && <MobileMenu onClose={() => setMenuOpen(false)} />}
        </>
    );
};
